import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import Link from 'components/Link';
import MailTo from 'components/MailTo';
import SettingsStore from 'stores/SettingsStore';
import User from 'entities/User';
import { promiseSettings } from 'promises/userBootData';

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '$FlowFixMeProps'.
class ShareRemindSocial extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    user: PropTypes.instanceOf(User).isRequired,
    medium: PropTypes.oneOf(['email', 'facebook', 'twitter', 'pinterest']),
  };

  componentWillMount() {
    // TODO this should not be a concern of components
    promiseSettings();
  }

  getEncodedBody = (base: string) => {
    _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
    const compiled = _.template(base);
    const body = compiled({ user_id: this.props.user.id, platform: 'web' });
    return body;
  };

  getLink = (): string | undefined | null => {
    const { medium } = this.props;
    const setting = this.getSetting();

    let url = setting[`${this.getRole()}_url`];
    let body = setting[this.getRole()];
    let base;

    if (medium === 'facebook') {
      body = this.getEncodedBody(url);
      base = 'https://www.facebook.com/sharer/sharer.php';
      return `${base}?u=${body}`;
    }

    if (medium === 'twitter') {
      body = this.getEncodedBody(body);
      base = 'https://www.twitter.com/home';
      return `${base}?status=${body}`;
    }

    if (medium === 'pinterest') {
      url = this.getEncodedBody(url);
      const media = this.getEncodedBody(setting.image);

      body = this.getEncodedBody(body);
      base = 'https://www.pinterest.com/pin/create/button/';

      return `${base}?url=${url}&media=${media}&description=${body}`;
    }
    return null;
  };

  getRole = () => {
    return this.props.user.getRole();
  };

  getSetting = () => {
    const { medium } = this.props;
    return SettingsStore.getSettings().sharing[medium];
  };

  render() {
    if (!SettingsStore.getSettings()) {
      return null;
    }

    if (this.props.medium === 'email') {
      const setting = this.getSetting()[this.getRole()];
      const body = this.getEncodedBody(setting.body.text);
      const subject = setting.subject;
      const bcc = setting.bcc;

      return (
        <MailTo
          {...this.props}
          className={cx('ShareRemindSocial', this.props.className)}
          subject={subject}
          body={body}
          bcc={bcc}
        >
          {this.props.children}
        </MailTo>
      );
    }

    return (
      <Link
        {...this.props}
        className={cx('ShareRemindSocial', this.props.className)}
        href={this.getLink()}
        target="_blank"
      >
        {this.props.children}
      </Link>
    );
  }
}

export default ShareRemindSocial;
